
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 24,
  viewBox: "0 0 14 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.2 23.995H1.183c-.65 0-1.18-.53-1.18-1.18V1.568c0-.65.53-1.18 1.18-1.18H12.2c.65 0 1.18.53 1.18 1.18v21.247c0 .65-.53 1.18-1.18 1.18zm.393-22.427a.393.393 0 0 0-.393-.393H1.183a.393.393 0 0 0-.393.393v1.967h11.803V1.568zm0 2.754H.79v14.165h11.803V4.322zm0 14.952H.79v3.54c0 .217.176.394.393.394H12.2a.394.394 0 0 0 .393-.393v-3.541zM6.692 22.42a1.18 1.18 0 1 1 1.18-1.18c0 .65-.53 1.18-1.18 1.18zm0-1.574a.394.394 0 1 0 0 .788.394.394 0 0 0 0-.788zM5.905 1.962h1.573a.393.393 0 1 1 0 .787H5.905a.393.393 0 1 1 0-.787z",
  fill: "#4A4A4A",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"24\" viewBox=\"0 0 14 24\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#4A4A4A\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <path d=\"M12.2 23.995H1.183c-.65 0-1.18-.53-1.18-1.18V1.568c0-.65.53-1.18 1.18-1.18H12.2c.65 0 1.18.53 1.18 1.18v21.247c0 .65-.53 1.18-1.18 1.18zm.393-22.427c0-.217-.176-.393-.393-.393H1.183c-.217 0-.393.176-.393.393v1.967h11.803V1.568zm0 2.754H.79v14.165h11.803V4.322zm0 14.952H.79v3.54c0 .217.176.394.393.394H12.2c.217 0 .393-.177.393-.393v-3.541zM6.692 22.42c-.651 0-1.18-.53-1.18-1.18 0-.651.529-1.18 1.18-1.18.65 0 1.18.529 1.18 1.18 0 .65-.53 1.18-1.18 1.18zm0-1.574c-.218 0-.394.177-.394.394 0 .217.176.393.394.393.216 0 .393-.176.393-.393 0-.217-.177-.394-.393-.394zM5.905 1.962h1.573c.218 0 .394.176.394.393 0 .218-.176.394-.394.394H5.905c-.218 0-.394-.176-.394-.394 0-.217.176-.393.394-.393z\" transform=\"translate(-330 -361) translate(40 360) translate(290 1)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mobile-black.b94bc47e254415f15a5107ab99fcf877.svg"),
        {
          React: SvgMobileBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      